const data = {
    "anime":
    {
        title:'ANIME / MANGA',
        info:"I've never lost the love for cartoons, especially for japanese anime, and i still watch them (integrating with a healthy dose of manga readings). One of my life goals is to visit Japan.",
    },
    "games":
    {
        title:'VIDEOGAMES',
        info:"Original, isn't it ? When possible (maybe too often) i like to turn on my gaming device and start a new adventure. Member of Halo Aeternum Community, one of the most important italian Halo community, but I don't refuse FPS or MOBA (League of Legends).",
    },
    "tech":
    {
        title:'TECH',
        info: "As you can imagine I'm addicted to technlogy (if not, why would I have studied computer engineering ?). I always stay updated on the latest news about tech in all its forms: computers, mobile, motors and discoveries.",
    },
    "friends":
    {
        title:'SOCIAL LIFE',
        info:"If you have read all the previous choices you may think I'm some kind of psychopath, but i'm not (i swear, trust me !). I always find time to spend with my friends, tabletop games or disco party ? I'm in !",
    }

}

export default data;